import { EChatMessageSource, IChatMessage } from '@adaptiva/core/chat';
import { Destroyer } from '@adaptiva/core/common';
import { computed, Directive, ElementRef, inject, input, InputSignal, signal, Signal, TemplateRef, WritableSignal } from '@angular/core';

@Directive()
export abstract class BaseBubbleComponent<T = any> extends Destroyer {

	protected readonly element: ElementRef = inject(ElementRef);

	protected readonly isActive: InputSignal<boolean> = input(false);

	protected readonly message: InputSignal<IChatMessage<T>> = input.required();

	protected readonly timestampTemplate: Signal<TemplateRef<ElementRef>> = input.required();

	protected readonly menuTemplate: Signal<TemplateRef<ElementRef>> = input.required();

	protected readonly isMenuVisible: WritableSignal<boolean> = signal(false);

	protected readonly isQuery: Signal<boolean> = computed(() => {
		return this.message().source === EChatMessageSource.QUERY;
	});

	public scrollIntoView(): void {
		this.element.nativeElement.scrollIntoView({
			behavior: 'smooth',
			block: 'nearest'
		});
	}

}
